import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LoginRedirectService, POS_PWA_URL } from 'src/app/core/services/login-redirect.service';

/**
 * M8 (Alex 04/11) — app POS di động cũ `/pos-mobile-app/**` đã gỡ. Link đã ghim hoặc lối tắt
 * màn hình chính trỏ vào đó phải sang POS PWA `/pos-m/`, không gãy thành trang 404.
 *
 * `/pos-m/` là một ứng dụng dựng RIÊNG (nginx phục vụ `dist/pos-pwa`), không phải route của
 * coresys ⇒ không dùng `redirectTo` được (router coresys sẽ rơi vào wildcard 404). Phải rời SPA
 * bằng một lượt tải trang đầy đủ — qua `LoginRedirectService.assign` để spec theo dõi được.
 *
 * Không chuyển token: POS PWA đọc họ khoá `CoreSysPOS:*` riêng và tự hỏi đăng nhập khi thiếu.
 */
export const posPwaRedirectGuard: CanActivateFn = () => {
  inject(LoginRedirectService).assign(POS_PWA_URL);
  return false;
};
